import EventEmitter from './EventEmitter.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { TextureLoader, CubeTextureLoader } from 'three'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import * as THREE from 'three'

export default class Resources extends EventEmitter
{
    constructor(sources)
    {
        super()

        // options
        this.sources = sources

        // setup
        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0
        
        this.setLoaders()
        this.startLoading()
    }

    setLoaders()
    {
        this.loaders = {}
        
        this.loaders.gltfLoader = new GLTFLoader()
        this.loaders.objLoader = new OBJLoader()
        this.loaders.textureLoader = new TextureLoader()
        this.loaders.cubeTextureLoader = new CubeTextureLoader()
        this.loaders.fontLoader = new FontLoader()
    }

    startLoading()
    {
        // Load each source
        for(const source of this.sources)
        {
            if(source.type === 'gltfModel')
            {
                this.loaders.gltfLoader.load(source.path, (file) =>
                {
                    this.sourceLoaded(source, file)
                })
            }
            else if(source.type === 'texture')
            {
                this.loaders.textureLoader.load(source.path, (file) =>
                {
                    this.sourceLoaded(source, file)
                })
            }
            else if(source.type === 'cubeTexture')
            {
                this.loaders.cubeTextureLoader.load(source.path, (file) =>
                {
                    this.sourceLoaded(source, file)
                    
                })
            }
            else if(source.type === 'objModel')
            {
                this.loaders.objLoader.load(source.path, (file) =>
                {
                    this.sourceLoaded(source, file)
                })
            }
            else if(source.type === 'font')
            {
                this.loaders.fontLoader.load(source.path, (file) =>
                {
                    this.sourceLoaded(source, file)
                })
            }
        }
    }

    sourceLoaded(source, file)
    {
        this.items[source.name] = file
        this.loaded++

        const progress = (this.loaded / this.toLoad) * 100

        this.trigger('fileLoaded', [progress])

        if(this.loaded === this.toLoad)
        {
            console.log('finished loading')
            this.trigger('ready')
        }
    }
    
    
}